import { LegalEntityTransaction } from './legal-entity-transaction';
import { BaseTransaction } from './base-transaction';

export class Transaction extends BaseTransaction {
  legalEntityTransactions: [LegalEntityTransaction, LegalEntityTransaction];
}
